import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {PasFilterType} from '../../shared/components/side-bar-double/menu-data.service';

@Injectable({
  providedIn: 'root'
})
export class PasFiltersStoreService implements StoreService {

  constructor(private storage: StorageService) { }

  set(type: PasFilterType, value: any):void {
    this.storage.setItem(type, JSON.stringify(value));
  }

  get(type: PasFilterType): any{
    const res = this.storage.getItem(type);
    if(!res || res==="undefined") return;
    return JSON.parse(res) as FilterFormData;
  }

  remove(type: PasFilterType): void {
    this.storage.removeItem(type);
  }

}
